/**
 * Single source of truth for the services Digitally Baffled sells.
 *
 * Shared by the server-side MCP tools (src/lib/mcp/tools.ts) and the in-browser
 * WebMCP tools (src/lib/webmcp/tools.ts) so both expose an identical catalogue.
 * Plain data only — safe to import on the client and the edge runtime.
 */

import { brand } from "@/config/brand";
export const SITE_URL = brand.url;

export interface ServiceEntry {
  title: string;
  slug: string;
  summary: string;
}

export const SERVICES: ServiceEntry[] = [
  {
    title: "AI Web & App Design",
    slug: "ai-web-app-design",
    summary:
      "Websites from £500, apps from £1,500 — built fast with AI workflows. Mobile-first, SEO/AEO/GEO-ready and fully yours to own.",
  },
  {
    title: "Marketing",
    slug: "marketing",
    summary:
      "PPC, Google Ads, Facebook and Instagram Ads set up and managed. Campaigns built around real goals, not vanity metrics.",
  },
  {
    title: "Ongoing Support",
    slug: "ongoing-support",
    summary:
      "Ongoing digital support from £50–£75/hr — website updates, SEO/AEO/GEO improvements, technical help and account management.",
  },
  {
    title: "Vision to Launch",
    slug: "vision-to-launch",
    summary:
      "From concept to a fully branded, operational business — identity, social branding, SEO/AEO foundations and company registration.",
  },
  {
    title: "Branded Client Portal & App",
    slug: "client-portal",
    summary:
      "Your own branded client portal and mobile app — clients track progress, sign agreements, pay invoices, message you and book calls, all under your brand. Setup from £1,500, £75/month care plan.",
  },
];

/** Permissive email shape check — server-side RLS is the real gate. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
